(()=>{
 if(window.cpMobileHeaderCleanup)window.cpMobileHeaderCleanup();
 const lifecycle=new AbortController();
 let controls;
 function initialize(){
  if(controls)controls.abort();
  controls=new AbortController();
  const signal=controls.signal;
  const header=document.querySelector('.cp-home-header');
  const menu=header?.querySelector('.cp-mobile-menu');
  if(!menu)return;
  const toggle=menu.querySelector('.cp-menu-toggle');
  document.addEventListener('keydown',event=>{
   if(event.key==='Escape'&&menu.open){menu.open=false;toggle.focus();}
  },{signal});
  document.addEventListener('pointerdown',event=>{
   if(menu.open&&!menu.contains(event.target))menu.open=false;
  },{signal});
  menu.addEventListener('click',event=>{
   if(event.target.closest('a'))menu.open=false;
  },{signal});
  const desktop=window.matchMedia('(min-width: 701px)');
  desktop.addEventListener('change',event=>{if(event.matches)menu.open=false;},{signal});
 }
 initialize();
 document.addEventListener('shopify:section:load',initialize,{signal:lifecycle.signal});
 document.addEventListener('shopify:section:unload',()=>queueMicrotask(initialize),{signal:lifecycle.signal});
 window.cpMobileHeaderCleanup=()=>{if(controls)controls.abort();lifecycle.abort();};
})();
